<!-- 预约结果 -->
<template>
	<div id="result">
		<van-nav-bar
			:title="$t('Result.title')"
			left-arrow
			fixed
			@click-left="$router.go(-2)"
		>
		</van-nav-bar> 
		<div class="success">{{$t('Result.success')}}</div>
		<van-cell :title="$t('Result.name')" :value='client.name'></van-cell>
		<van-cell :title="$t('Result.phone')" :value='client.phone'></van-cell>
		<van-cell :title="$t('Result.mealTime')" :value='client.meal_time'></van-cell>
		<van-cell :title="$t('Result.mealNum')" :value="client.meal_number+$t('Result.people')"></van-cell>  
	</div>
</template>
<script>
		export default {
			data(){
				return{
					client:{
						name:'',
						phone:'',
						meal_number:'',
						meal_time:'',
					},
					id:sessionStorage.getItem('id'),
				}
			},	
			mounted(){
				this.getReserveDetail();
			},
			methods:{
				getReserveDetail(){
					this.$axios({
						method:'get',
						headers:{
							'code':sessionStorage.code
						},
						url:this.$build+'/api/book/'+this.id+'/customerIndex',
					}).then(res =>{
						console.log(res);
						if(res.data.status==200){
							this.client=res.data.data;
										
						}else{
							this.$toast.allowMultiple();
							for (var item in res.data.error) {
								this.$toast({
									type:'fail',
									message:res.data.error[item],
								});
							}
						}
					}).catch(err =>{
						this.$toast({
							type:'fail',
							message:this.$t('common.message'),
						});
					});
				},
			}
		}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #fff;
	}
		.success{
			padding-top: 46px;
			height: 100px;
			text-align: center;
			line-height: 100px;
			font-size: 30px;
			color: #84D48D;
			font-weight: bold;
		}
</style>


// WEBPACK FOOTER //
// src/reserve/Result.vue